import { defineStore } from "pinia";
import { getApiBaseUrl } from "../components/ApiBaseUrl.js";

const API_BASE = getApiBaseUrl();

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthed: false,
    user: null,
  }),
  actions: {
    // 서버 API로 로그인 수행
    async login({ id, password }) {
      try {
        const res = await fetch(`${API_BASE}/api/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, password }),
        });

        const data = await res.json();
        if (data.ok) {
          this.isAuthed = true;
          this.user = data.user;
          return { ok: true };
        } else {
          return { ok: false, error: data.message || "login failed" };
        }
      } catch (err) {
        console.error("Login error", err);
        return { ok: false, error: "network error" };
      }
    },

    // 서버에 사용자 계정 생성 요청
    async register({ id, password, username, email }) {
      try {
        const body = { id, password };
        if (username) body.username = username;
        if (email) body.email = email;
        const res = await fetch(`${API_BASE}/api/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          return { ok: false, error: err.message || "server error" };
        }
        const data = await res.json();
        return data;
      } catch (err) {
        console.error("Register error", err);
        return { ok: false, error: "network error" };
      }
    },

    logout() {
      this.isAuthed = false;
      this.user = null;
    },
  },
});
